package modysy.menu

import modysy.InputHandler
import modysy.gamestate.{GameState, GameStateManager}
import modysy.view.Color
import org.scalajs.dom

class IngameMenu(
    stateManager: GameStateManager,
    inputs: InputHandler,
    width: Double,
    height: Double
) extends AbstractMenu(inputs, width, height) {

  {
    //val pauseButton = new TextButton(width * 0.075, height * 0.975, "Pause")
    val pauseButton = new TextButton(width * 0.5, 55, "Pause")
    pauseButton.fontSize = Math.round(60).toInt
    pauseButton.action = () => {
      stateManager.pauseGame()
    }
    pauseButton.colorSelected = Color.Yellow

    buttons = pauseButton :: buttons
    buttons.foreach(button => {
      val tmp = button.isEnabled
      button.isEnabled = () => {
        tmp() && (stateManager.gameState == GameState.ingamePlaying)
      }
    })
    buttons.foreach(button => {
      button.enableTouch(inputs)
    })
  }

  override def render(ctx: dom.CanvasRenderingContext2D): Unit = {
    super.render(ctx)
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/IngameMenu.scala